import { createFileRoute } from "@tanstack/react-router";

import { TaskManagerPage } from "@/components/pages/TaskManagerPage";
import { type TaskManagerTab, VALID_TABS } from "@/lib/task-manager";

interface TaskManagerSearch {
  tab?: TaskManagerTab;
}

export const Route = createFileRoute("/_authenticated/task-manager/")({
  validateSearch: (search: Record<string, unknown>): TaskManagerSearch => ({
    tab: VALID_TABS.includes(search.tab as TaskManagerTab)
      ? (search.tab as TaskManagerTab)
      : undefined,
  }),
  component: TaskManagerPage,
});
